<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'vendas-turnos') {
            next({ name: 'vendas-turno-list' });
        } else if (to.name == 'agro-turnos') {
            next({ name: 'agro-turno-list' });
        } else if (to.name == 'des-turno') {
            next({ name: 'des-turno-list' });
        } else if (to.name == 'promotor-turnos') {
            next({ name: 'promotor-turno-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'vendas-turnos') {
            this.$router.push({ name: 'vendas-turno-list' });
        } else if (this.$route.name == 'agro-turnos') {
            this.$router.push({ name: 'agro-turno-list' });
        } else if (this.$route.name == 'des-turno') {
            this.$router.push({ name: 'des-turno-list' });
        } else if (this.$route.name == 'promotor-turnos') {
            this.$router.push({ name: 'promotor-turno-list' });
        }
    },
};
</script>
